import React from "react";
import Book from "../assets/icons/icon_book.gif";

interface SocratesLoadingProps {
  message?: string;
}

/**
 * SocratesLoading
 * 소크라테스 면접 준비/생성 중 로딩 화면
 */
const SocratesLoading: React.FC<SocratesLoadingProps> = ({
  message = "면접을 준비하는 중입니다...",
}) => {
  return (
    <div className="flex w-full h-full items-center justify-center">
      <div className="flex items-center gap-2 text-base font-bold">
        <img src={Book} alt="loading" className="w-8" />
        <p>{message}</p>
      </div>
    </div>
  );
};

export default SocratesLoading;
